import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import Dropdown from "../../primitives/Dropdown";
import { ENRICHMENT_CATEGORIES } from "../constants";

/**
 * Modal for configuring enrichment data
 */
const EnrichmentModal = ({ open, onClose, onSubmit, modalState, onStateChange }) => {
  const { category, enrichmentType } = modalState;

  const handleCategoryChange = (event) => {
    const newCategory = event.target.value;
    onStateChange("category", newCategory);
    // Reset enrichment type when category changes
    onStateChange("enrichmentType", "");
  };

  const handleEnrichmentTypeChange = (event) => {
    onStateChange("enrichmentType", event.target.value);
  };

  const handleSubmit = () => {
    onSubmit();
  };

  // Get available enrichment types for the selected category
  const categoryOptions = Object.keys(ENRICHMENT_CATEGORIES);
  // Coerce invalid category to '' to avoid MUI out-of-range
  const safeCategory = categoryOptions.includes(category) ? category : "";
  const availableTypes = safeCategory ? ENRICHMENT_CATEGORIES[safeCategory] || [] : [];
  // Coerce invalid enrichmentType to '' to avoid MUI out-of-range
  const safeEnrichmentType = availableTypes.includes(enrichmentType) ? enrichmentType : "";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Configure Enrichment Data</DialogTitle>
      <DialogContent>
        <Dropdown
          label="Category"
          id="enrichment-category"
          name="category"
          value={safeCategory}
          onChange={handleCategoryChange}
          options={categoryOptions}
        />

        <Dropdown
          label="Enrichment Type"
          id="enrichment-type"
          name="enrichmentType"
          value={safeEnrichmentType}
          onChange={handleEnrichmentTypeChange}
          options={availableTypes}
          disabled={!category}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={!category || !enrichmentType}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EnrichmentModal;
